// MUI Components
import Grid from "@mui/material/Grid";

// Components
import EyeReport from "./EyeReport";

// Utilities
import { ReportEachSectionContext } from "../../../contexts/CommentContext";
import { ReportDataContext } from "../../../contexts/ReportDataContext";
import { useContext, useMemo } from "react";
import { examCardEnums } from "../../../enums";

const EstermanReport = () => {
  const sectionName = examCardEnums.VISUAL_FIELD_ESTERMAN.sectionName;
  const { reportData } = useContext(ReportDataContext);
  const {
    examReport,
    eyeReport,
    comments,
    sectionId,
    duration,
    durationStartTime,
  } = reportData?.[sectionName] ?? {};

  const ReportSectionContent = useMemo(() => {
    return (
      <Grid container sx={{ display: "flex" }} columnSpacing={4}>
        <ReportEachSectionContext.Provider
          value={{
            examReport,
            eyeReport,
            comments,
            sectionId,
            duration,
            durationStartTime,
          }}
        >
          {examReport && (
            <Grid item xs={12} lg={6} pt={4}>
              <EyeReport />
            </Grid>
          )}
        </ReportEachSectionContext.Provider>
      </Grid>
    );
  }, [comments, examReport, sectionId, duration, durationStartTime, eyeReport]);

  return <>{ReportSectionContent}</>;
};

export default EstermanReport;
